import { useTranslation } from 'react-i18next'

import { ComboBox, Divider, Text } from '@reveni-io/reveni-ui'

import { bundleAllowedRequestsOptions, bundleOptions, bundleValues } from './constants'
import * as Styles from './styles'

const BundlesConfiguration = ({
  bundleReturnPolicy,
  setBundleReturnPolicy,
  bundleAllowedRequests,
  setBundleAllowedRequests,
  allowReturns,
  allowExchanges,
  disabled,
}) => {
  const { t } = useTranslation()

  const showAllowedRequests = bundleReturnPolicy === bundleValues.allTogether && allowReturns && allowExchanges

  return (
    <Styles.Container>
      <Divider />
      <Text type="titleM">{t('Paquetes de productos')}</Text>
      <Text type="bodyMRegular">
        {t(
          'Define si tus clientes pueden devolver los paquetes de productos por separado o en conjunto. Si es en conjunto, se tendrán que validar todos los productos del paquete devuelto como una sola unidad.'
        )}
      </Text>
      <ComboBox
        label={t('Devolución de paquetes de productos')}
        menuItems={bundleOptions.map(o => ({ ...o, label: t(o.label) }))}
        handleChange={e => setBundleReturnPolicy(e.target.value)}
        value={bundleReturnPolicy}
        disabled={disabled}
      />
      {showAllowedRequests && (
        <ComboBox
          label={t('Solicitudes permitidas')}
          menuItems={bundleAllowedRequestsOptions.map(o => ({ ...o, label: t(o.label) }))}
          handleChange={e => setBundleAllowedRequests(e.target.value)}
          value={bundleAllowedRequests}
          disabled={disabled}
        />
      )}
    </Styles.Container>
  )
}

export default BundlesConfiguration
